import { FunctionComponent } from "react";

interface GeneralLoaderProps {}

const GeneralLoader: FunctionComponent<GeneralLoaderProps> = () => {
  return (
    <div className="loaderContainer">
      <div className="span-container">
        <span className="one"></span>
        <span className="two"></span>
        <span className="three"></span>
        <span className="four"></span>
      </div>
    </div>
  );
};

export default GeneralLoader;
